import React from 'react';

// Minimal, single-style icon set (stroke-based, 24x24 viewBox) used across the
// sidebar nav. Kept dependency-free so no icon package needs to be installed.
const PATHS = {
  dashboard: 'M4 13h6V4H4v9zm0 7h6v-5H4v5zm10 0h6v-9h-6v9zm0-16v5h6V4h-6z',
  skills: 'M12 2l2.4 6.6L21 11l-6.6 2.4L12 20l-2.4-6.6L3 11l6.6-2.4L12 2z',
  packages: 'M21 8l-9-5-9 5 9 5 9-5zM3 8v8l9 5 9-5V8M12 13v8',
  suites: 'M4 6h16M4 12h16M4 18h16',
  overlays: 'M12 2a10 10 0 100 20 10 10 0 000-20zM2 12h20M12 2a15 15 0 010 20 15 15 0 010-20z',
  customers: 'M17 21v-2a4 4 0 00-4-4H7a4 4 0 00-4 4v2M10 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75',
  workspaces: 'M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6',
  entitlements: 'M14.5 9.5a3.5 3.5 0 11-4.9-4.9 3.5 3.5 0 014.9 4.9zM10.6 13.4L3 21',
  creditPools: 'M2 8h20M2 6h20v12H2V6zm4 9h4',
  agents: 'M9 7h6a2 2 0 012 2v3a2 2 0 01-2 2H9a2 2 0 01-2-2V9a2 2 0 012-2zM12 3v4M9 20l-1-2h8l-1 2M7 12H4M20 12h-3',
  runs: 'M4 12h3l2-7 4 14 2-7h5',
  tasks: 'M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01',
  routing: 'M6 3v8a3 3 0 003 3h6M18 3v3M18 18v3M18 6a3 3 0 100 6 3 3 0 000-6zM6 3a3 3 0 100 6 3 3 0 000-6zM18 18a3 3 0 100-6 3 3 0 000 6z',
  goals: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z',
  approvals: 'M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  integrations: 'M9 3v4M15 3v4M6 7h12l-1 5a5 5 0 01-10 0L6 7zM9 21v-4M15 21v-4',
  audit: 'M8 3h8l4 4v14H4V3h4zm0 0v4H4M8 12h8M8 16h8',
  reports: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  search: 'M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35',
  refresh: 'M4 4v6h6M20 20v-6h-6M4 10a8 8 0 0114.6-4.6M20 14a8 8 0 01-14.6 4.6',
  check: 'M20 6L9 17l-5-5',
  close: 'M18 6L6 18M6 6l12 12',
  external: 'M14 4h6v6M10 14L20 4M20 14v6H4V4h6',
  lock: 'M6 11V8a6 6 0 1112 0v3M5 11h14v10H5V11zM12 15v3',
  upload: 'M12 16V4M7 9l5-5 5 5M4 20h16',
};

export function Icon({ name, className }) {
  const d = PATHS[name];
  if (!d) return null;
  return (
    <svg
      className={className || 'nav-icon'}
      viewBox="0 0 24 24"
      width="17"
      height="17"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}

export default Icon;
